export default __webpack_public_path__ + "static/media/edit.b8736d7e.svg";